module.exports = __webpack_public_path__ + "img/shoppingCart_white.43f4ccbc.svg";